export default __webpack_public_path__ + "static/media/mainnet.02e1fd92.webp";